import { render } from "./CronometroVue.vue?vue&type=template&id=3c2db6e9&scoped=true&ts=true"
import script from "./CronometroVue.vue?vue&type=script&lang=ts"
export * from "./CronometroVue.vue?vue&type=script&lang=ts"

import "./CronometroVue.vue?vue&type=style&index=0&id=3c2db6e9&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c2db6e9"]])

export default __exports__